import { DatePicker, Table, Tag } from "antd";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";

import dayjs from "dayjs";
import { useParams } from "react-router-dom";
import { loadSingleLeaveHistory } from "../../redux/rtk/features/leave/leaveSlice";
import getPermissions from "../../utils/getPermissions";
import ViewBtn from "../Buttons/ViewBtn";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import BtnViewSvg from "../UI/Button/btnViewSvg";

const { RangePicker } = DatePicker;

function CustomTable({ list, loading, filteredList, setDateRange, dateRange }) {
	const [columnsToShow, setColumnsToShow] = useState([]);
	const permissions = getPermissions();

	const hasPermission = (item) => {
		return permissions?.includes(item ? item : "");
	};
	console.log("permissions", permissions);


	console.log(list);

	const columns = [
		{
			id: 1,
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
			// render: (text, record, index) => index+1
		},

		{
			id: 3,
			title: "Leave Type",
			dataIndex: "leavePolicy",
			key: "leavePolicy",
			render: (leavePolicy) => leavePolicy?.name || "N/A",
		},
		{
			id: 4,
			title: "Leave From",
			dataIndex: "leaveFrom",
			key: "leaveFrom",
			render: (leaveFrom) => dayjs(leaveFrom).format("DD-MM-YYYY"),
		},
		{
			id: 5,
			title: "Leave To",
			dataIndex: "leaveTo",
			key: "leaveTo",
			render: (leaveTo) => dayjs(leaveTo).format("DD-MM-YYYY"),
		},
		{
			id: 6,
			title: "Leave Duration",
			dataIndex: "leaveDuration",
			key: "leaveDuration",
			render: (leaveDuration) => {
				if (leaveDuration > 0) {
					return <span>{leaveDuration} days</span>;
				} else {
					return <span>{leaveDuration} day</span>;
				}
			},
		},

		{
			id: 7,
			title: "Status",
			dataIndex: "status",
			key: "status",
			render: (status) => {
				if (status === "ACCEPTED") {
					return <Tag color='green'>{status.toUpperCase()}</Tag>;
				} else if (status === "REJECTED") {
					return <Tag color='red'>{status.toUpperCase()}</Tag>;
				} else {
					return <Tag color='orange'>{status.toUpperCase()}</Tag>;
				}
			},
		},

		{
			id: 7,
			title: "Applied On",
			dataIndex: "createdAt",
			render: (createdAt) => dayjs(createdAt).format("DD-MM-YYYY"),
		},

		// {
		// 	id: 7,
		// 	title: "Action",
		// 	key: "action",
		// 	render: ({ id }) => (
		// 		<ViewBtn
		// 			path={`/admin/leave/${id}`}
		// 			text='View'
		// 			icon={<BtnViewSvg />}
		// 		/>
		// 	),
		// },
	];

	if (hasPermission("readSingle-leaveApplication")) {
		columns.push({
			id: 9,
			title: "Action",
			key: "action",
			render: ({ id }) => (
				<ViewBtn
					path={`/admin/leave/${id}`}
					text='View'
					icon={<BtnViewSvg />}
				/>
			),
		});
	}

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	// const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
	const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));


	return (
		<div className='ant-card p-4 rounded mt-0'>
			<div className='flex my-2 justify-between'>
				<div className='w-50'>
					<h4 className='text-2xl mb-2'> My Leave Applications</h4>
				</div>
				{list && (
					<div className='flex justify-end mr-4'>
						<div className='mt-0.5 flex items-center gap-2'>
							<div>
								<RangePicker
									value={dateRange}
									onChange={(dates) => setDateRange(dates)}
									format="YYYY-MM-DD"
									placeholder={['Start Date', 'End Date']}
									className='rounded'
								/>
							</div>
							<CsvLinkBtn>
								<CSVLink
									data={(filteredList || list).map((item,index) => ({
										sNo: index + 1, 
										leaveType: item.leavePolicy?.name || "N/A",
										leaveFrom: item.leaveFrom ? dayjs(item.leaveFrom).format("DD-MM-YYYY") : "N/A",
										leaveTo: item.leaveTo ? dayjs(item.leaveTo).format("DD-MM-YYYY") : "N/A",
										totalleaveDays: item.totalleaveDays ?? "N/A",
										acceptLeaveFrom: item.acceptLeaveFrom ? dayjs(item.acceptLeaveFrom).format("DD-MM-YYYY") : "N/A",
										acceptLeaveTo: item.acceptLeaveTo ? dayjs(item.acceptLeaveTo).format("DD-MM-YYYY") : "N/A",
										status: item.status || "N/A",
									}))}
									headers={[
										{ label: "S.No", key: "sNo" }, 
										{ label: "Leave Type", key: "leaveType" },
										{ label: "Leave From", key: "leaveFrom" },
										{ label: "Leave To", key: "leaveTo" },
										{ label: "Leave Duration", key: "totalleaveDays" },
										{ label: "Accepted Leave From", key: "acceptLeaveFrom" },
										{ label: "Accepted Leave To", key: "acceptLeaveTo" },
										{ label: "Status", key: "status" },
									]}
									// data={list}
									className='btn btn-dark btn-sm'
									style={{ marginTop: "5px" }}
									filename='leave_applications'>
									Download CSV
								</CSVLink>
							</CsvLinkBtn>
						</div>
					</div>
				)}
			</div>
			{list && (
				<div style={{ marginBottom: "30px" }}>
					<ColVisibilityDropdown
						options={columns}
						columns={columns}
						columnsToShowHandler={columnsToShowHandler}
					/>
				</div>
			)}
			<Table
				className='text-center'
				scroll={{ x: true }}
				loading={loading}
				columns={columnsToShow}
				dataSource={filteredList ? addKeys(filteredList) : list ? addKeys(list) : []}
			/>
		</div>
	);
}

const UserLeave = (props) => {
	const { id } = useParams("id");
	const dispatch = useDispatch();
	const list = useSelector((state) => state.leave.leaveHistory);
	const loading = useSelector((state) => state.leave.loading);
	
	// State for date range - default to current month
	const [dateRange, setDateRange] = useState(() => {
		const startOfMonth = dayjs().startOf('month');
		const endOfMonth = dayjs().endOf('month');
		return [startOfMonth, endOfMonth];
	});
	
	// State for filtered list
	const [filteredList, setFilteredList] = useState([]);

	useEffect(() => {
		dispatch(loadSingleLeaveHistory(id));
	}, []);

	// Filter list based on date range
	useEffect(() => {
		if (list?.singleLeave && dateRange && dateRange[0] && dateRange[1]) {
			const startDate = dateRange[0].startOf('day');
			const endDate = dateRange[1].endOf('day');
			
			const filtered = list.singleLeave.filter(item => {
				const createdAt = dayjs(item.createdAt);
				return createdAt.isAfter(startDate) && createdAt.isBefore(endDate) || 
					   createdAt.isSame(startDate, 'day') || 
					   createdAt.isSame(endDate, 'day');
			});
			
			setFilteredList(filtered);
		} else {
			setFilteredList(list?.singleLeave || []);
		}
	}, [list, dateRange]);

	return (
		<UserPrivateComponent permission={"readSingle-leaveApplication"}>
			{/* <div className='card'> */}
			<div>

				<div className='card-body'>
					<CustomTable 
						list={list?.singleLeave} 
						loading={loading}
						filteredList={filteredList}
						setDateRange={setDateRange}
						dateRange={dateRange}
					/>
				</div>
			</div>
		</UserPrivateComponent>
	);
};

export default UserLeave;
